import 'whatwg-fetch';
import Cookies from 'js-cookie';

const apiRoot = 'https://api.spotify.com/v1';

function retrievePlaylists() {
  const accessToken = Cookies.get('linkchase_spotify_access_token');
  return fetch(`${apiRoot}/me/playlists?limit=50`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${accessToken}`,
      'Content-Type': 'application/json'
    }
  }).then((response) => response.json());
}

export default {
  retrievePlaylists,
  addTrackToPlaylist
};

function addTrackToPlaylist(playlistId, trackUri) {
  const accessToken = Cookies.get('linkchase_spotify_access_token');
  return fetch(`${apiRoot}/playlists/${playlistId}/tracks`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${accessToken}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ uris: [trackUri] })
  }).then((response) => response.json());
}
